var _circle, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 51,
    r: 49.5,
    stroke: "url(#paint0_radial_2:179107)",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 51 51",
    to: "360 51 51",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.3821 66.3511L28.8633 45.7285C25.9055 42.247 26.3705 37.0064 29.8957 34.0852C33.4209 31.1641 38.7272 31.6234 41.685 35.1049L59.2039 55.7275C62.1616 59.209 61.6966 64.4496 58.1714 67.3708C54.6463 70.2919 49.3399 69.8326 46.3821 66.3511Z",
    fill: "url(#paint1_radial_2:179107)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3245 42.1454L60.9808 62.69C60.0414 67.1406 55.5814 70.0204 51.075 69.0926C46.5685 68.1648 43.6526 63.7601 44.592 59.3095L48.9357 38.765C49.8751 34.3143 54.3351 31.4345 58.8415 32.3623C63.3526 33.2947 66.2685 37.6948 65.3245 42.1454Z",
    fill: "url(#paint2_radial_2:179107)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2317 66.3511L50.7129 45.7285C47.7551 42.247 48.2201 37.0064 51.7453 34.0852C55.2705 31.1641 60.5768 31.6234 63.5346 35.1049L81.0535 55.7275C84.0113 59.209 83.5462 64.4496 80.021 67.3708C76.5005 70.2919 71.1942 69.8326 68.2317 66.3511Z",
    fill: "url(#paint3_radial_2:179107)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2552 60.3563C35.6598 65.4499 31.3905 69.6663 26.233 69.2667C22.1777 68.9498 18.8944 65.7071 18.5735 61.6974C18.1689 56.6038 22.4381 52.3874 27.5956 52.787C31.651 53.1039 34.939 56.3512 35.2552 60.3563Z",
    fill: "url(#paint4_radial_2:179107)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    className: "around",
    id: "paint0_radial_2:179107",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 53.5) scale(102)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#EB6719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6719",
    stopOpacity: 0.24
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2:179107",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.1398 42.8027) scale(16.6546 16.4483)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E0B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1599,
    stopColor: "#B91319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3231,
    stopColor: "#CE181F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4857,
    stopColor: "#DE1A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#E81C23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ED1C24"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2:179107",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.0492 52.5389) rotate(0.790156) scale(16.7079 16.5011)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9E0B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4399,
    stopColor: "#B91319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5827,
    stopColor: "#CE181F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#DE1A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8649,
    stopColor: "#E81C23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1C24"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2:179107",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.6175 34.1456) scale(35.6478 35.2063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37021"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2:179107",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.8818 63.9488) scale(12.5082 12.3533)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E0B0F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.5656cddadb4fda2ccc4f7981e5c1e5fa.svg";
export { ForwardRef as ReactComponent };